/* global Autodesk, THREE */ // eslint-disable-line
import { updateMarkupModal } from "../../helpers/actions/Action";

import store from "../../helpers/store/Store";

import { connect } from "react-redux";

class MarkupExtension extends Autodesk.Viewing.Extension {
  constructor(viewer, options) {
    super(viewer, options);
    this._button = null;
    this._group = null;

    // this.boolMarkupModal = false;
    // this.state = { boolMarkupModal: false };
  }

  load() {
    console.log("button extension loaded");
    return true;
  }

  unload() {
    console.log("button extension unloaded");
    return true;
  }

  onToolbarCreated() {
    // Create a new toolbar group if it doesn't exist
    this._group = this.viewer.toolbar.getControl("MarkupExtensionToolbar");
    if (!this.group) {
      this._group = new Autodesk.Viewing.UI.ControlGroup(
        "MarkupExtensionToolbar"
      );
      this.viewer.toolbar.addControl(this._group);
    }
    // Add a new button to the toolbar group
    this._button = new Autodesk.Viewing.UI.Button("NewButton");
    this._button.onClick = () => {
      //   const tempMarkupModal = !this.state.boolMarkupModal;
      //   this.boolMarkupModal = !this.boolMarkupModal;

      //   this.setState({ boolMarkupModal: tempMarkupModal });

      //   console.log("MarkupModal", this.state.boolMarkupModal);

      //   store.dispatch(updateMarkupModal(this.boolMarkupModal));

      //   addToolbar();

      this._createToggler(
        this._button,
        this._addToolbar,
        this._removeToolbar,
        this.viewer
      );
    };
    //Add Markup Button To Viewer Panel
    // this._button.setIcon("icon-open-markups");
    // this._button.setToolTip("Markups");
    // this._button.addClass("NewButtonIcon");
    // this._group.addControl(this._button);
  }

  _createToggler = function (button, addToolbar, removeToolbar, viewer) {
    var state = button.getState();

    console.log("STATE", state);

    if (state === Autodesk.Viewing.UI.Button.State.INACTIVE) {
      button.setState(Autodesk.Viewing.UI.Button.State.ACTIVE);

      addToolbar(viewer);
    } else if (state === Autodesk.Viewing.UI.Button.State.ACTIVE) {
      button.setState(Autodesk.Viewing.UI.Button.State.INACTIVE);

      removeToolbar(viewer);
    }
  };

  _addToolbar = function (viewer) {
    viewer.loadExtension("MarkupToolbarExtension");
  };

  _removeToolbar = function (viewer) {
    // let extension = viewer.getExtension("MarkupToolbarExtension");
    // extension.unload();
    viewer.unloadExtension("MarkupToolbarExtension");
  };
}

// const addToolbar = () => {
//   console.log("HITTT");
//   if (this.state.boolMarkupModal) {
//     this.viewer.loadExtension("MarkupToolbarExtension");
//   } else {
//     this.viewer.unloadExtension("MarkupToolbarExtension");
//   }
// };

// const mapStateToProps = (state) => ({
//   MarkupModal: state.markupModalReducer.markupModal,
// });

// export default connect(mapStateToProps)(MarkupExtension);

Autodesk.Viewing.theExtensionManager.registerExtension(
  "MarkupExtension",
  MarkupExtension
);
